import { useLocale } from '../i18n/LocaleProvider'
import { DeviceMobile, Code, Brain, Cpu, TShirt } from '@phosphor-icons/react'
import type { Icon } from '@phosphor-icons/react'
import './ApplicableProducts.css'

const products: { icon: Icon; name: string; desc: string }[] = [
  {
    icon: DeviceMobile,
    name: 'Apps',
    desc: 'Consumer and enterprise mobile and web applications — engineered to feel native to Japanese users from the very first interaction.',
  },
  {
    icon: Code,
    name: 'Software-based Services',
    desc: 'SaaS platforms, APIs, developer tools, and B2B software products ready for enterprise procurement cycles in Japan.',
  },
  {
    icon: Brain,
    name: 'AI-related Services',
    desc: 'LLMs, ML platforms, AI agents, and intelligent automation products entering a market with a 46% adoption gap and enormous unmet demand.',
  },
  {
    icon: Cpu,
    name: 'Hardware',
    desc: 'Connected devices, IoT products, and physical tech navigating Japan\'s retail, distribution, and certification landscape.',
  },
  {
    icon: TShirt,
    name: 'Fashion',
    desc: 'DTC fashion and lifestyle brands building a loyal Japanese consumer presence through strategic local entry and cultural alignment.',
  },
]

export default function ApplicableProducts() {
  const { t } = useLocale()
  return (
    <section id="plug-and-play" className="ap-section">
      <div className="container">
        <div className="ap-layout">

          <div className="ap-left">
            <span className="tag">{t("Who We Serve")}</span>
            <h2>{t("Plug-and-Play Japan Market Entry for Your Startup")}</h2>
            <p> {t("We specialize in taking SaaS and AI startups — from early-stage indie builders to mid-scale companies — into the Japanese market. Whether you run on subscriptions, usage, or units, we know the path forward.")} </p>
          </div>

          <div className="ap-right">
            {products.map((p) => (
              <div className="ap-item" key={p.name}>
                <span className="ap-icon">
                  <p.icon size={36} weight="bold" />
                </span>
                <div className="ap-item-body">
                  <h3>{t(p.name)}</h3>
                  <p>{t(p.desc)}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  )
}
